import './rich-text.scss';

/**
 * version    1.0
 * class      <type> (RichText)
 * classdesc
 */
export class RichText {}
